
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"100","height":"100","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"next","transform":"translate(-1116.176 -652.499)"}},[_c('g',{attrs:{"id":"Group_20748","data-name":"Group 20748","transform":"translate(1116.176 652.5)"}},[_c('circle',{attrs:{"id":"Ellipse_282","data-name":"Ellipse 282","cx":"50","cy":"50","r":"50","transform":"translate(0 0)","fill":"#ff0009"}}),_c('g',{attrs:{"id":"Group_20747","data-name":"Group 20747","transform":"translate(37.869 27.275)"}},[_c('path',{attrs:{"id":"Path_189810","data-name":"Path 189810","d":"M172.442,647.361a11.074,11.074,0,0,1,.667,4.015c0,3.443-2.009,6.792-7.075,10.619-8.7,6.695-14.06,10.8-17.122,13.389-3.155-1.053-4.877-3.062-4.877-6.028,0-4.495,4.211-9.277,12.054-16.161-8.7-5.645-11.669-9.852-11.669-13.677,0-5.357,3.826-8.9,8.415-8.9a11.593,11.593,0,0,1,2.391.288C157.616,634.447,161.439,638.943,172.442,647.361Z","transform":"translate(-144.033 -630.621)","fill":"#fff"}})])])])])
          )
        }
      }
    